import { CaseReducer, createSlice, PayloadAction } from "@reduxjs/toolkit";

type initialType = {
  accessToken: string | null;
  fcmToken: string | null;
  isAuthenticated: boolean;
  isPwaSupport: boolean;
  language: string;
  refreshToken: string | null;
  showPWA: boolean;
};

const initialState: initialType = {
  accessToken: "",
  fcmToken: "",
  isAuthenticated: false,
  isPwaSupport: false,
  language: "",
  refreshToken: "",

  showPWA: true,
};

type localSliceReducer<Payload> = CaseReducer<
  initialType,
  PayloadAction<Payload>
>;

const checkPwaSupport: localSliceReducer<boolean> = (state, action) => {
  state.isPwaSupport = action.payload;
};

const setFcmToken: localSliceReducer<string | null> = (state, action) => {
  state.fcmToken = action.payload;
};

const clearStorage: localSliceReducer<null> = state => {
  state.accessToken = "";
  state.refreshToken = "";
  state.isAuthenticated = false;
};

const switchInstallPwaBanner: localSliceReducer<boolean> = (state, action) => {
  state.showPWA = action.payload;
};

const userAuthenticated: localSliceReducer<{
  isAuthenticated: boolean;
  refresh_token: string;
  token: string;
}> = (state, action) => {
  state.accessToken = action.payload.token;
  state.refreshToken = action.payload.refresh_token;
  state.isAuthenticated = action.payload.isAuthenticated;
};

export const localSlice = createSlice({
  initialState,
  name: "local",
  reducers: {
    checkPwaSupport,
    clearStorage,
    setFcmToken,
    switchInstallPwaBanner,
    userAuthenticated,
  },
});

export default localSlice;
